// joints
export const SELECT_JOINTS = 'SELECT_JOINTS'
export const SELECT_JOINTS_REV = 'SELECT_JOINTS_REV'
export const UNSELECT_JOINTS = 'UNSELECT_JOINTS'
export const CHANGE_JOINTS = 'CHANGE_JOINTS'

export const SELECT_JOINT_MASTERS = 'SELECT_JOINT_MASTERS'
export const UNSELECT_JOINT_MASTERS = 'UNSELECT_JOINT_MASTERS'
export const CHANGE_JOINT_MASTERS = 'CHANGE_JOINT_MASTERS'

export const UPDATED_JOINTS = 'UPDATED_JOINTS'
export const UPDATED_JOINT_MASTERS = 'UPDATED_JOINT_MASTERS'

// poles
export const SELECT_POLES = 'SELECT_POLES'
export const SELECT_POLES_REV = 'SELECT_POLES_REV'
export const UNSELECT_POLES = 'UNSELECT_POLES'
export const CHANGE_POLES = 'CHANGE_POLES'

export const SELECT_POLE_MASTERS = 'SELECT_POLE_MASTERS'
export const UNSELECT_POLE_MASTERS = 'UNSELECT_POLE_MASTERS'
export const CHANGE_POLE_MASTERS = 'CHANGE_POLE_MASTERS'

export const UPDATED_POLES = 'UPDATED_POLES'
export const UPDATED_POLE_MASTERS = 'UPDATED_POLE_MASTERS'

// other
export const CHANGE_ROAD_NAME = 'CHANGE_ROAD_NAME'
export const SET_ROAD_NAME = 'SET_ROAD_NAME'
export const SET_FOCUS_AREA = 'SET_FOCUS_AREA'
export const UNSET_FOCUS_AREA = 'UNSET_FOCUS_AREA'
